/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { bool } from '@ember/object/computed';
import Composer from 'cio/components/action-composer/base';
import { tagName } from '@ember-decorators/component';
import { observes } from '@ember-decorators/object';

@tagName('')
export default class Twilio extends Composer {
  @service store;

  previewObserverKeys = ['editableEntity.template.{fromIdentity,recipient,body,imageUrl}'];
  previewURL = 'previews/twilio';

  getPreviewData() {
    let { template } = this.editableEntity;
    let { fromIdentity } = template;
    return {
      from: fromIdentity?.phone,
      to: template.recipient,
      body: template.body,
      image_url: template.imageUrl,
    };
  }

  cacheOriginalRelationships() {
    this.set('_originalFromIdentity', this.editableEntity.template.fromIdentity);
  }

  init() {
    super.init(...arguments);
    this.cacheOriginalRelationships();
  }

  // eslint-disable-next-line ember/no-observers
  @observes('editableEntity.template.id')
  onTemplateSwitch() {
    this.cacheOriginalRelationships();
  }

  // eslint-disable-next-line getter-return
  @computed('editableEntity.template.fromIdentity')
  get noSenderIdentityError() {
    if (!this.editableEntity.template.fromIdentity) {
      return 'select "from" phone number';
    }
  }

  @bool('noSenderIdentityError')
  isInvalid;

  @computed('_originalFromIdentity.id', 'editableEntity.template.{fromIdentity.id,hasDirtyAttributes}')
  get isDirty() {
    let isFromDirty = this.get('_originalFromIdentity.id') !== this.editableEntity.template.get('fromIdentity.id');

    return isFromDirty || this.editableEntity.template.hasDirtyAttributes;
  }

  @action
  save() {
    let promise = this.onSave();

    promise.then(
      () => {
        this.cacheOriginalRelationships();
      },
      () => {},
    );

    return promise;
  }

  @action
  rollback() {
    let { template } = this.editableEntity;

    template.rollbackAttributes();
    if (this._originalFromIdentity) {
      template.set('fromIdentity', this._originalFromIdentity);
    }

    this.onRollback();
  }
}
